


import React, { useState } from "react";
import { BookOpen, Brain, PenTool, Send, Headphones, Shield, RefreshCcw, Users } from 'lucide-react';
import { FaTasks, FaUserGraduate, FaChartLine, FaUsers, FaGlobe, FaRedo } from "react-icons/fa";
import CountUp from "react-countup";
import { FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination,Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import researchImg from '../images/research.png';
import ideaImg from '../images/idea.png';
import writeImg from '../images/write.png';
import deliverImg from '../images/deliver.png';
import supportImg from '../images/support.png';
import securityImg from '../images/security.png';
import flexibleImg from '../images/flexible.png';
import connectImg from '../images/connect.png';
import refundImage from '../images/refun.png'; // Adjust path as needed




import { FaTwitter, FaFacebook, FaInstagram, FaEnvelope } from "react-icons/fa";
const features = [
  {
    icon: researchImg,
    title: "Research",
    description: "In-depth research before writing to ensure high-quality assignments."
  },
  {
    icon: ideaImg,
    title: "Ideate",
    description: "Creative and knowledgeable brainstorming for unique content."
  },
  {
    icon: writeImg,
    title: "Write",
    description: "Expert writers craft assignments with precision and excellence."
  },
  {
    icon: deliverImg,
    title: "Deliver",
    description: "Timely submission to help you achieve the best grades."
  },
  {
    icon: supportImg,
    title: "24/7 Support",
    description: "Experts available round the clock for assistance."
  },
  {
    icon: securityImg,
    title: "Confidential",
    description: "We guarantee complete confidentiality and data security."
  },
  {
    icon: flexibleImg,
    title: "Flexible",
    description: "Adaptive services catering to your needs every time."
  },
  {
    icon: connectImg,
    title: "Connect",
    description: "Easily reach our experts with just one click."
  }
];



const blogData = [
  {
    id: 1,
    title: "Structuring and Organizing Your Work",
    image: "https://plus.unsplash.com/premium_photo-1661284828052-ea25d6ea94cd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8d29ya3xlbnwwfHwwfHx8MA%3D%3D",
    date: "April 24, 2025",
    excerpt: "Learn how to structure your assignment with a clear introduction, body, and conclusion for maximum impact.",
    bgGradient: "from-yellow-500 to-yellow-600"
  },
  {
    id: 2,
    title: "Technology in Assignments",
    image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    date: "April 23, 2025",
    excerpt: "Explore how tools like Grammarly, Trello, and Google Docs can boost your assignment quality.",
    bgGradient: "from-cyan-500 to-cyan-700"
  },
  {
    id: 3,
    title: "Utilizing Libraries and Study Groups",
    image: "https://images.unsplash.com/photo-1683871268982-a19153dbb35d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    date: "April 22, 2025",
    excerpt: "Maximize your academic potential by using libraries, databases, and collaborating with peers.",
    bgGradient: "from-amber-600 to-red-500"
  },
  {
    id: 4,
    title: "Stress Management Techniques",
    image: "https://images.unsplash.com/photo-1456406644174-8ddd4cd52a06?q=80&w=2048&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    date: "April 21, 2025",
    excerpt: "Reduce academic stress with effective techniques like mindfulness, yoga, and task breakdown.",
    bgGradient: "from-gray-700 to-purple-800"
  },
  {
    id: 5,
    title: "Seeking Help the Right Way",
    image: "https://source.unsplash.com/600x400/?help,education",
    date: "April 20, 2025",
    excerpt: "Understand when and how to seek academic help from professors, peers, and online forums.",
    bgGradient: "from-red-600 via-orange-600 to-yellow-500"
  }
];

// Optional: gradient classes to rotate across cards
const gradientClasses = [
  "bg-gradient-to-br from-indigo-400 to-indigo-600",
  "bg-gradient-to-br from-blue-400 to-blue-600",
  "bg-gradient-to-br from-pink-400 to-pink-600",
  "bg-gradient-to-br from-teal-400 to-teal-600",
  "bg-gradient-to-br from-yellow-300 to-yellow-500",
  "bg-gradient-to-br from-green-400 to-green-600",
  "bg-gradient-to-br from-purple-400 to-purple-600",
  "bg-gradient-to-br from-red-400 to-red-600",
];




const benefits = [
    {
      title: "Wide-Ranging Expertise",
      description: "Our team includes specialists in numerous disciplines.",
      img: "https://cdn-icons-png.flaticon.com/512/8920/8920621.png",
      color: "from-blue-400 to-indigo-500",
    },
    {
      title: "Human-Made Assignments",
      description: "Crafted by real experts, not machines.",
      img: "https://cdn-icons-png.freepik.com/256/3673/3673355.png?semt=ais_white_label",
      color: "from-pink-400 to-red-500",
    },
    {
      title: "Affordable Prices",
      description: "Quality-assured services at budget-friendly rates.",
      img: "https://cdn-icons-png.flaticon.com/512/3343/3343387.png",
      color: "from-purple-400 to-blue-400",
    },
    {
      title: "AI & Plagiarism-Free Content",
      description: "100% AI and plagiarism-free content, ensuring originality.",
      img: "https://cdn-icons-png.flaticon.com/512/1048/1048966.png",
      color: "from-yellow-300 to-orange-400",
    },
    {
      title: "Timely Delivery",
      description: "We prioritize meeting deadlines, ensuring prompt delivery.",
      img: "https://cdn-icons-png.flaticon.com/512/2639/2639273.png",
      color: "from-teal-400 to-green-400",
    },
   
    {
      title: "100% Money-Back Guarantee",
      description: "If our work doesn't meet standards, we offer a full refund or free revision.",
      img: "https://cdn-icons-png.flaticon.com/512/3756/3756405.png",
      color: "from-indigo-400 to-blue-400",
    },
  
  ];

const achievements = [
    { count: 12000, label: "Assignments Done", color: "bg-red-500", icon: <FaTasks /> },
    { count: 100, label: "Qualified Experts", color: "bg-blue-500", icon: <FaUserGraduate /> },
    { count: 95, label: "Passing Rate", color: "bg-purple-500", icon: <FaChartLine /> },
    { count: 4000, label: "Happy Customers", color: "bg-yellow-500", icon: <FaUsers /> },
    { count: 15, label: "Countries Served", color: "bg-green-500", icon: <FaGlobe /> },
    { count: 90, label: "Repeat Customers", color: "bg-indigo-500", icon: <FaRedo /> },
  ];

  const faqs = [
    {
      question: "What subjects do you cover in your assignment writing services?",
      answer: "We provide assistance across a wide range of subjects, including management, engineering, humanities, social sciences, law, healthcare, and more."
    },
    {
      question: "Are your assignments 100% plagiarism-free?",
      answer: "Yes, all assignments are written from scratch and thoroughly checked using advanced plagiarism detection tools."
    },
    {
      question: "How quickly can you deliver an assignment?",
      answer: "We offer flexible delivery timelines, including urgent assignments with tight deadlines. Assignments can be completed within as little as 24 hours."
    },
    {
      question: "Can I communicate with the writer working on my assignment?",
      answer: "Absolutely! We encourage direct communication between you and your writer to ensure your specific instructions and expectations are met."
    },
    {
      question: "What if I am not satisfied with the assignment?",
      answer: "Your satisfaction is our priority. If you're not happy with the work, we offer free revisions to address your concerns."
    },
    {
      question: "Is our services confidential?",
      answer: "Yes, we prioritize your privacy. Your personal and academic information is kept strictly confidential."
    },
  ];



  const teamMembers = [
    {
      name: "JOY BARUA",
      position: "CEO, CO-FOUNDER",
      image: "https://infinitesolutionedu.com/img/team-member/joyda2.png",
      twitter: "http://www.twitter.com/",
      facebook: "https://www.facebook.com/joy.barua.581",
      instagram: "https://www.instagram.com/j.b_12111990",
      email: "mailto:joy@example.com",
    },
    {
      name: "DEBJIT",
      position: "CEO, FOUNDER",
      image: "https://infinitesolutionedu.com/img/team-member/debjit%20(2).png",
      twitter: "http://www.twitter.com/",
      facebook: "https://www.facebook.com/debjit.datta.guddu",
      instagram: "https://www.instagram.com/debjitdatta",
      email: "mailto:debjit@example.com",
    },
  ];

  

function FeaturesSection() {
  const [activeTab, setActiveTab] = useState("essays");
  const tabs = [
    { key: "essays", label: "Essay Writing " },
    { key: "report writing", label: "Report Writing " },
    { key: "thesis writing", label: "Thesis " },
    { key: "otherProjects", label: "Poster Design " },
    { key: "dissertation", label: "Dissertation " },
  ];
    return (
<>


  
<a
  href="https://wa.me/917980085981"
  target="_blank"
  rel="noopener noreferrer"
  className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-2xl hover:scale-105 transform transition duration-300 ease-in-out text-3xl flex items-center justify-center"
>
  <FaWhatsapp />
</a>


  
      
    


<section
  className="bg-[#02042b] text-white py-16 px-8 md:px-12 -mt-40"
  data-aos="fade-up"
  data-aos-offset="200"
  data-aos-delay="100"
  data-aos-duration="1000"
>
  <div className="text-center max-w-3xl mx-auto px-4">
    <span className="text-blue-400 uppercase tracking-wide font-semibold block text-xl">
      Features
    </span>
    <h2 className="text-4xl font-bold mt-1 leading-tight">
      Get Assignment Help for <br />
      <span className="bg-gradient-to-r from-blue-300 via-blue-400 to-blue-500 text-transparent bg-clip-text">
        Higher Academic Grades
      </span>
    </h2>
    <p className="text-gray-300 mt-4 text-lg leading-relaxed">
      We are passionate academic writing experts, helping students worldwide since 2016.
    </p>
  </div>

  <div
    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-12"
    data-aos="zoom-in-up"
    data-aos-delay="200"
  >
    {features.map((feature, index) => (
      <div
        key={index}
        className={`relative p-6 rounded-xl shadow-xl text-center transition duration-300 ease-in-out
          bg-gradient-to-br ${gradientClasses[index % gradientClasses.length]} text-white
          hover:brightness-110 hover:ring-2 hover:ring-white/30 overflow-hidden`}
      >
        <div className="absolute top-0 left-[-75%] w-[50%] h-full bg-white/20 rotate-12 pointer-events-none " />
        <img
          src={feature.icon}
          alt={feature.title}
          className="w-16 h-16 mx-auto mb-4 drop-shadow-lg"
        />
        <h4 className="text-xl font-bold mb-2">{feature.title}</h4>
        <p className="text-white/90 font-semibold">{feature.description}</p>
      </div>
    ))}
  </div>
</section>



<section id="promo-video" className="relative py-20 bg-[#061027]">
{/* soft radial glow */}
<div className="pointer-events-none absolute inset-0 opacity-40 [background:radial-gradient(60%_50%_at_30%_20%,#1b2b6a_0%,transparent_60%)]" />


<div className="relative max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
{/* Left text */}
<div className="lg:col-span-5">
<span className="inline-flex items-center gap-2 text-xs tracking-wider uppercase text-sky-300/90 bg-white/5 ring-1 ring-white/10 rounded-full px-3 py-1">
<span className="h-1.5 w-1.5 rounded-full bg-sky-300" /> Seamless Student Support
</span>


<h2 className="mt-4 text-3xl md:text-5xl font-extrabold leading-tight bg-gradient-to-r from-sky-400 to-teal-300 bg-clip-text text-transparent">
Make Learning{" "}
<span className="bg-gradient-to-r from-sky-400 to-teal-300 bg-clip-text text-transparent">
Stress-Free
</span>
</h2>


<p className="mt-4 text-slate-300/95 text-lg leading-relaxed">
No last-minute panic. No second-guessing. Just well-prepared, original work delivered on time — with human help when you need it.
</p>


{/* Key points */}
<ul className="mt-6 space-y-3 text-slate-200">
{[
"On-time delivery with clear milestones",
"100% original drafts with sources & citations",
"1:1 doubt-clearing and revision support",
"Transparent pricing — no hidden fees",
].map((item, i) => (
<li key={i} className="flex items-start gap-3">
<span className="mt-1 shrink-0 rounded-full p-1 bg-teal-400/10 ring-1 ring-teal-300/30" />
<span className="leading-relaxed">{item}</span>
</li>
))}
</ul>


{/* CTAs */}
<div className="mt-7 flex flex-wrap items-center gap-3">

<a
href="#contact"
className="inline-flex items-center justify-center rounded-full px-5 py-2.5 text-sm font-semibold text-slate-100 bg-white/5 hover:bg-white/10 transition ring-1 ring-white/10"
>
Get Started
</a>
</div>
</div>


{/* Right video */}
<div className="lg:col-span-7">
<div className="relative rounded-3xl border border-white/10 bg-white/5 p-2 shadow-2xl shadow-black/40">
<div className="relative aspect-video rounded-2xl overflow-hidden ring-1 ring-white/10">
{/* Play overlay hint */}
<div className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-black/20 via-transparent to-transparent" />


<video
autoPlay
muted
loop
playsInline
preload="metadata"
className="absolute inset-0 w-full h-full object-cover"
poster="/poster.jpg"
>
<source src="./video.mp4" type="video/mp4" />
Your browser does not support the HTML5 video tag.
</video>


{/* Caption bar */}
<div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">

</div>
</div>
</div>
{/* small footnote */}
<p className="mt-3 text-xs text-slate-400"></p>
</div>
</div>
</section>

<section
      className="py-16 bg-[#02042b] text-white text-center"
      data-aos="fade-up"
      data-aos-offset="200"
      data-aos-delay="100"
      data-aos-duration="1000"
      style={{ backgroundColor: '#02042b' }} // Fallback to prevent white flash
    >
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-4xl font-bold mb-10 bg-gradient-to-r from-blue-400 via-blue-400 to-blue-500 text-transparent bg-clip-text">
  Our Achievements
</h2>


        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {achievements.map((item, index) => (
            <li
              key={index}
              className="p-6 rounded-xl border border-white/20 bg-white/10 backdrop-blur-md shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col items-center justify-center"
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div className={`text-5xl p-4 rounded-full text-white ${item.color}`}>
                {item.icon}
              </div>
              <h3 className="text-3xl font-semibold mt-4">
                <CountUp end={item.count} duration={3} />+
              </h3>
              <p className="text-gray-300 mt-2">{item.label}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>


<section
      className="w-full px-6 py-16 bg-[#02042b]"
      data-aos="fade-up"
      data-aos-offset="200"
      data-aos-delay="100"
      data-aos-duration="1000"
      style={{ backgroundColor: '#02042b' }} // Prevents white flash
    >
      <h2 className="bg-gradient-to-r from-yellow-300 via-amber-400 to-orange-700 text-transparent bg-clip-text tracking-tight font-poppins text-4xl font-bold mb-12 text-center animate-fade-in">
        Latest Academic Tips
      </h2>

      <div className="overflow-x-auto px-2 sm:px-6 md:px-12">
        <div className="flex gap-6 pb-4 w-max">
          {blogData.slice(0, 4).map((blog, index) => (
            <div
              key={blog.id}
              className={`min-w-[300px] max-w-xs bg-gradient-to-br ${blog.bgGradient} text-white rounded-2xl shadow-lg flex-shrink-0 transform transition-transform hover:scale-105 duration-300`}
              data-aos="zoom-in-up"
              data-aos-delay={index * 150}
            >
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-48 object-cover rounded-t-2xl"
              />
              <div className="p-4">
                <p className="text-sm text-white/80 mb-1">{blog.date}</p>
                <h3 className="text-lg font-bold mb-2 leading-snug">{blog.title}</h3>
                <p className="text-sm text-white/80 line-clamp-3">{blog.excerpt}</p>

                <Link
                  to="/whyus"
                  className="mt-4 inline-block text-sm font-semibold bg-white text-gray-900 px-4 py-2 rounded-lg hover:bg-gray-200 transition"
                >
                  Read More
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>



   <section
  className="py-16 bg-[#02042b] text-[#f2fcfb]"
  data-aos="fade-up"
  data-aos-offset="200"
  data-aos-delay="100"
  data-aos-duration="1000"
  style={{ backgroundColor: '#02042b' }} // ensures no white flash
>
  <div className="max-w-6xl mx-auto px-6 text-center">
    <p className="text-lg text-teal-400 font-semibold">Why Choose Us</p>

    <h2 className="text-3xl font-bold mt-2">
      Discover the <span className="text-blue-400">Benefits</span> of Learning With Us
    </h2>

    <p className="mt-3 text-gray-300">Expert guidance for stress-free learning</p>

    {/* Benefits Grid */}
    <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
      {benefits.map((benefit, index) => (
        <li
          key={index}
          className="p-6 rounded-xl shadow-lg transform hover:scale-105 transition-all duration-300 ease-in-out bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#334155] text-white"
          data-aos="zoom-in-up"
          data-aos-delay={index * 150}
        >
          <div className="flex items-center space-x-4 mb-2">
            <img
              src={benefit.img}
              alt={benefit.title}
              width={50}
              height={50}
              className="w-12 h-12"
            />
            <h3 className="text-lg font-semibold">{benefit.title}</h3>
          </div>
          <p className="text-sm text-gray-300">{benefit.description}</p>
        </li>
      ))}
    </ul>
  </div>
</section>




<section className="py-16 bg-[#02042b]">
<div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
  <div className="text-center mb-10">
    <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold pb-2 bg-gradient-to-r from-yellow-300 via-amber-400 to-orange-500 text-transparent bg-clip-text tracking-tight font-poppins">
      Assignment Assistance for Every Occasion
    </h2>
    <p className="text-gray-300 mt-3 max-w-2xl mx-auto text-lg sm:text-lg font-medium font-poppins">
      Struggling with academics? Get expert help for essays, research, thesis, and projects — tailored just for you.
    </p>
  </div>





    {/* Tabs */}
    <div className="flex flex-col sm:flex-row sm:justify-center sm:space-x-6 gap-3 sm:gap-0 mb-10 text-center">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => setActiveTab(tab.key)}
          className={`py-3 px-6 sm:py-4 sm:px-8 border-b-2 text-xl sm:text-2xl ${
            activeTab === tab.key
              ? "text-blue-400 border-blue-500"
              : "text-white border-transparent hover:text-blue-300"
          } transition-all duration-300 font-medium`}
        >
          {tab.label}
        </button>
      ))}
    </div>

    {/* Tab Content */}
    <div className="max-w-3xl mx-auto px-4">
    {activeTab === "essays" && (
  <div className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-black rounded-2xl p-6 shadow-2xl text-white overflow-hidden border border-blue-700 font-poppins animate-fade-in-up duration-700">

    {/* Twinkling Stars Background */}
    <div className="absolute inset-0 z-0 twinkling-stars pointer-events-none"></div>

    {/* Floating Rocket */}
    <div className="absolute top-4 right-6 text-4xl animate-bounce z-10">🚀</div>

    {/* Main Content */}
    <div className="relative z-10 space-y-4">
      <h3 className="text-3xl font-extrabold tracking-wide text-white flex items-center gap-2">
        ✨ Essay Writing Services
      </h3>

      <p className="text-blue-100 text-base md:text-lg font-medium leading-relaxed">
        Get essays that impress — original, structured, and tailored to your academic level.
      </p>

      <ul className="text-sm md:text-base text-blue-200 list-disc pl-5 space-y-2 font-semibold">
        <li>📝 Descriptive, Reflective, Argumentative Essays</li>
        <li>📚 Harvard, APA, MLA, and Chicago Formats</li>
        <li>⏰ Turnitin Reports, Fast Delivery, Free Revisions</li>
      </ul>

      <a
        href="https://wa.me/917980085981"
        className="inline-block mt-4 bg-blue-600 hover:bg-blue-700 transition text-white font-semibold py-2 px-6 rounded-full shadow-lg tracking-wide"
      >
  📝 Get Info
      </a>
    </div>
  </div>
)}





      

{activeTab === "report writing" && (
  <div className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-black rounded-2xl p-6 shadow-2xl text-white overflow-hidden border border-blue-700 font-poppins animate-fade-in-up duration-700">

    {/* Twinkling Stars Background */}
    <div className="absolute inset-0 z-0 twinkling-stars pointer-events-none"></div>

    {/* Floating Document Icon */}
    <div className="absolute top-4 right-6 text-4xl animate-bounce z-10">📄</div>

    {/* Main Content */}
    <div className="relative z-10 space-y-4">
      <h3 className="text-3xl font-extrabold tracking-wide text-white flex items-center gap-2">
        📑 Report Writing Services
      </h3>

      <p className="text-blue-100 text-base md:text-lg font-medium leading-relaxed">
        Professionally written, research-driven reports customized for your academic or corporate needs. From technical writeups to analytical summaries — we handle it all.
      </p>

      <ul className="text-sm md:text-base text-blue-200 list-disc pl-5 space-y-2 font-semibold">
        <li>📊 Technical, Analytical & Research Reports</li>
        <li>📚 Harvard, APA, MLA, and other formatting styles</li>
        <li>🕒 Timely Delivery + Proper Citations + Free Revisions</li>
      </ul>

      <a
        href="https://wa.me/917980085981"
        className="inline-block mt-4 bg-blue-600 hover:bg-blue-700 transition text-white font-semibold py-2 px-6 rounded-full shadow-lg tracking-wide"
      >
        📥 Get Quote
      </a>
    </div>
  </div>
)}


{activeTab === "thesis writing" && (
  <div className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-black rounded-2xl p-6 shadow-2xl text-white overflow-hidden border border-blue-700 font-poppins animate-fade-in-up duration-700">

    {/* Twinkling Stars Background */}
    <div className="absolute inset-0 z-0 twinkling-stars pointer-events-none"></div>

    {/* Floating Icon */}
    <div className="absolute top-4 right-6 text-4xl animate-bounce z-10">🎓</div>

    {/* Main Content */}
    <div className="relative z-10 space-y-4">
      <h3 className="text-3xl font-extrabold tracking-wide text-white flex items-center gap-2">
        🎓 Thesis Writing Assistance
      </h3>

      <p className="text-blue-100 text-base md:text-lg font-medium leading-relaxed">
        Our PhD-level experts help you craft a compelling, research-rich thesis with proper structure, citations, and academic tone — across all disciplines.
      </p>

      <ul className="text-sm md:text-base text-blue-200 list-disc pl-5 space-y-2 font-semibold">
        <li>🧪 Topic Selection, Literature Review, Methodology</li>
        <li>📚 APA, MLA, Harvard, IEEE Citation Styles</li>
        <li>🔍 100% Plagiarism-Free with Turnitin Reports</li>
      </ul>

      <a
        href="https://wa.me/917980085981"
        className="inline-block mt-4 bg-blue-600 hover:bg-blue-700 transition text-white font-semibold py-2 px-6 rounded-full shadow-lg tracking-wide"
      >
        📝 Get Quote
      </a>
    </div>
  </div>
)}


{activeTab === "otherProjects" && (
  <div className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-black rounded-2xl p-6 shadow-2xl text-white overflow-hidden border border-blue-700 font-poppins animate-fade-in-up duration-700">

    {/* Twinkling Stars Background */}
    <div className="absolute inset-0 z-0 twinkling-stars pointer-events-none"></div>

    {/* Floating Icon */}
    <div className="absolute top-4 right-6 text-4xl animate-bounce z-10">🖼️</div>

    {/* Main Content */}
    <div className="relative z-10 space-y-4">
      <h3 className="text-3xl font-extrabold tracking-wide text-white flex items-center gap-2">
        🖼️ Poster Design & Other Projects
      </h3>

      <p className="text-blue-100 text-base md:text-lg font-medium leading-relaxed">
        From custom posters to case studies, business plans, coding help, and more — our experts are here to bring your vision to life.
      </p>

      <ul className="text-sm md:text-base text-blue-200 list-disc pl-5 space-y-2 font-semibold">
        <li>🎨 Creative Poster Design for Events, Academics & Promotions</li>
        <li>🧾 Dissertations, Case Studies, Business & Marketing Plans</li>
        <li>🧑‍💻 Coding Projects, Proofreading & Editing Services</li>
      </ul>

      <a
        href="https://wa.me/917980085981"
        className="inline-block mt-4 bg-blue-600 hover:bg-blue-700 transition text-white font-semibold py-2 px-6 rounded-full shadow-lg tracking-wide"
      >
        📝 Get Info
      </a>
    </div>
  </div>
)}


{activeTab === "dissertation" && (
  <div className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-black rounded-2xl p-6 shadow-2xl text-white overflow-hidden border border-blue-700 font-poppins animate-fade-in-up duration-700">

    {/* Twinkling Stars Background */}
    <div className="absolute inset-0 z-0 twinkling-stars pointer-events-none"></div>

    {/* Floating Icon */}
    <div className="absolute top-4 right-6 text-4xl animate-bounce z-10">📚</div>

    {/* Main Content */}
    <div className="relative z-10 space-y-4">
      <h3 className="text-3xl font-extrabold tracking-wide text-white flex items-center gap-2">
        📚 Dissertation Writing Help
      </h3>

      <p className="text-blue-100 text-base md:text-lg font-medium leading-relaxed">
        Our experts provide in-depth research, academic structuring, and precise referencing to deliver high-quality dissertations tailored to your subject and university requirements.
      </p>

      <ul className="text-sm md:text-base text-blue-200 list-disc pl-5 space-y-2 font-semibold">
        <li>🔍 Research Methodology, Literature Review, Analysis</li>
        <li>📚 APA, MLA, Harvard, Chicago, IEEE Formatting</li>
        <li>✅ Plagiarism-Free with Turnitin Reports & Revisions</li>
      </ul>

      <a
        href="https://wa.me/917980085981"
        className="inline-block mt-4 bg-blue-600 hover:bg-blue-700 transition text-white font-semibold py-2 px-6 rounded-full shadow-lg tracking-wide"
      >
        📩 Get Quote
      </a>
    </div>
  </div>
)}





    </div>
  </div>
</section>


   


<section className="bg-[#02042b] text-white py-16 px-7">
  <div className="container mx-auto flex flex-col lg:flex-row items-center justify-between gap-12">

    {/* Left - Content */}
    <div className="w-full lg:w-1/2 text-center lg:text-left">
      <h3 className="text-4xl font-bold bg-gradient-to-r from-blue-200  to-blue-400 text-transparent bg-clip-text leading-snug">
        REFUND AND <br /> CANCELLATION POLICY 
      </h3>
      <p className="mt-4 text-lg text-gray-300">
        Your satisfaction is our priority. Learn more about our straightforward refund and cancellation policy for peace of mind.
      </p>
      <div className="mt-6">
        <Link to="/refund">
          <button className="px-6 py-3 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 text-[#02042b] font-semibold rounded-lg shadow-md hover:bg-[#3bb0a1] transition duration-300">
            Read More
          </button>
        </Link>
      </div>
    </div>

    {/* Right - Image */}
    <div className="w-full lg:w-1/2 flex justify-center lg:justify-end">
      <img
        src={refundImage}
        alt="Refund"
        className="w-full max-w-md rounded-lg shadow-lg"
      />
    </div>
    
  </div>
</section>


 <section className="py-20 bg-[#02042b]">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <h2 className="text-3xl font-bold text-center text-white mb-2">
      Hear Success Stories from Students Like You
    </h2>
    <p className="text-center text-gray-300 mb-10">
      Real feedback from those who turned deadlines into distinctions with our guidance.
    </p>

    <Swiper
      modules={[Pagination, Autoplay]}
      pagination={{ clickable: true }}
      spaceBetween={30}
      slidesPerView={1}
      autoplay={{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }}
      loop={true}
      autoHeight={true}                   // ← let Swiper adjust to each slide's height
      breakpoints={{
        640: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      }}
      className="pb-10"
    >
      {testimonials.map((t, i) => (
        <SwiperSlide key={i}>
          <a
            href={t.link}
            target="_blank"
            rel="noopener noreferrer"
            className="block hover:scale-[1.02] transition-transform duration-200"
            aria-label={`Read full review by ${t.name}`}
          >
            {/* let content define height; use gap instead of justify-between */}
            <div className="bg-white rounded-2xl shadow-xl p-6 mx-2 flex flex-col gap-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <img
                    src="https://cdn-icons-png.flaticon.com/128/2784/2784403.png"
                    alt="avatar"
                    className="w-8 h-8 rounded-full"
                  />
                  <h3 className="text-sm font-semibold text-gray-800">{t.name}</h3>
                </div>
                <img
                  src="https://cdn-icons-png.flaticon.com/128/300/300221.png"
                  alt="Google icon"
                  className="w-5 h-5"
                />
              </div>

              <div className="flex items-center">
                {[...Array(5)].map((_, j) => (
                  <svg key={j} className="w-4 h-4 text-yellow-400 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975h4.184c.969 0 1.371 1.24.588 1.81l-3.39 2.46 1.287 3.974c.3.922-.755 1.688-1.54 1.117l-3.392-2.46-3.392 2.46c-.784.57-1.838-.195-1.539-1.117l1.287-3.974-3.39-2.46c-.783-.57-.38-1.81.588-1.81h4.183L9.05 2.927z" />
                  </svg>
                ))}
                <svg className="w-4 h-4 text-green-500 ml-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z" clipRule="evenodd" />
                </svg>
              </div>

              {/* FULL text: no clamp, allow wrapping & line breaks */}
              <p className="text-sm text-gray-700 whitespace-pre-line">{t.feedback}</p>
            </div>
          </a>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
</section>




    <div className="bg-[#02042b] text-white py-16 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold bg-gradient-to-r from-indigo-400 via-blue-500 to-indigo-300 text-transparent bg-clip-text">Frequently Asked Questions</h2>
      </div>

      {/* Two-column grid layout with equal height */}
      <div className="max-w-7xl mx-auto mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        {faqs.map((faq, index) => (
          <details key={index} className="bg-[#1e2a47] rounded-lg overflow-hidden min-h-[60px] flex flex-col">
            <summary className="w-full text-left py-4 px-6 cursor-pointer flex justify-between items-center hover:bg-[#273352] transition-all">
              <span className="text-lg font-medium">{faq.question}</span>
              <span className="text-xl">+</span>
            </summary>
            <p className="px-6 py-3 bg-[#16213e] text-gray-300 flex-grow">{faq.answer}</p>
          </details>
        ))}
      </div>
    </div>

    <div className="relative bg-gradient-to-r from-[#02042b] via-[#031b5b] to-[#042e87] py-16 px-4 overflow-hidden">
      {/* Curved Shape */}
      <div className="absolute inset-0 bg-white/10 backdrop-blur-lg rounded-tl-[50%] rounded-br-[50%] transform rotate-[-5deg]"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center text-[#f2fcfb]">
        <h3 className="text-3xl font-bold mb-6">
          Get Admission in Your Dream University! <br /> Get in Touch!
        </h3>

       <a
  href="https://wa.me/917980085981"  
  target="_blank"
  className="bg-white/20 text-white text-lg font-semibold py-3 px-8 rounded-full shadow-lg hover:bg-white/30 transition-all"
>
  Contact Us 
</a>

      </div>
    </div>
</>

        
       
    );
}

const testimonials = [
  {
    name: "Harsha Vardhan Reddy",
    feedback:
      "I had a fantastic experience working with this team on my project. They were professional, responsive, and highly skilled throughout the entire process. The quality of the work exceeded my expectations, and everything was delivered on time. I’m extremely satisfied with the results—my project turned out even better than I had imagined. I highly recommend this team to anyone looking for reliable and top-notch service!",
    link: "https://share.google/fgCxqIOQVBdCTpwdz"
  },
  {
    name: "Swathy",
    feedback:
      "I  had done my project work and assignment with this company they are very cooperative and supportive.I could score good marks for my assignments . They are good in technical assignments and project . They even accept and reply to messages on time so am very happy with there them. Thank you once again",
    link: "https://share.google/RJSQsWGWNufr0AbeP"
  },
  {
    name: "Pramod vishnu Das",
    feedback:
      "Mr Mrinal is a very supportive and trustworthy person. He has provided 5 assignments for those who are studying in the UK, and all of them got more than 75 marks. Thank you, Mrinal, bro; you are really a very nice and supportive person.",
    link: "https://share.google/8rL4rpBoabLot4Oiz"
  },
  {
    name: "Muhammad Mounis Murad",
    feedback:
      "Highly recommended. Mam Samarpita helped me a lot and get me 70% marks in my university assignments. She was really helpful. She makes sure that everything should be done according to university standards.",
    link: "https://share.google/8GqpQPNK4UoWvCPNA"
  },
  {
    name: "Thadishetty Santhosh",
    feedback:
      "Hi team. I’m happy with u co-operative. I got 72% in my masters. My trainer name is Koyel. She is very loyal and honestly.And also I like her 😜 and she is very cute. She is lady super star for studies.",
    link: "https://share.google/MuXHU0yCGvLSGtiud"
  },
  {
    name: "San Deep.",
    feedback:
      "I was the second class topper in the assignment and Samarpita Chattoraj was very helpful and she arranged a meeting with writer to have a clear explanation and I am very happy with their services",
    link: "https://share.google/MikUZ6B4gc1XelHM8"
  },
  
];



export default FeaturesSection;
